import { Box } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import Arranger from '../../base/arranger';
import Button from '../../base/button';
import { spc } from '../../base/spacer';
import Text from '../../base/text';
import useProjectPolicyLeftNavContext, {
  PolicyContextInfo,
} from '../left-nav/left-nav-context';

import { Pencil1, Bin1 } from '~c/components/base/icon';

interface Props {
  className?: string;
  policyInfo: PolicyContextInfo;
}

const SelectedPolicyImpl: React.FC<Props> = ({ className, policyInfo }) => {
  const { removeSelectedPolicy, setConfigurePolicyId } =
    useProjectPolicyLeftNavContext();

  const {
    policy: { id: policyId },
  } = policyInfo;

  return (
    <Box className={className}>
      <Arranger direction="column">
        <Text sz="bold-body12" className="policy-label">
          {policyInfo.policy.name ?? 'Label'}
        </Text>
        <div className="policy-actions">
          <Button
            tertiary
            icon={Bin1}
            onClick={() => removeSelectedPolicy(policyId)}
          />
          <Button
            tertiary
            icon={Pencil1}
            onClick={() => setConfigurePolicyId(policyId)}
          />
        </div>
      </Arranger>
    </Box>
  );
};

const SelectedPolicy = muiStyled(SelectedPolicyImpl)(({ theme }) => {
  return css`
    border-radius: 16px;
    border: 1px solid ${theme.palette.secondary.main};
    padding: ${theme.spacing(spc.container_padding_m)};
    margin-bottom: ${theme.spacing(spc.between_vertical_s)};

    .policy-label {
      white-space: break-spaces;
      margin-bottom: ${theme.spacing(spc.between_vertical_s)};
    }
    .policy-actions {
      display: flex;
      justify-content: flex-end;
    }
  `;
});

export default SelectedPolicy;
